import { useRegisterSW } from 'virtual:pwa-register/react';

import { UpdateNotification } from './UpdateNotification';

export default function UpdateNotificationSW() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    immediate: true,
    onRegisteredSW(swUrl, r) {
      r &&
        setInterval(async () => {
          if (!(!r.installing && navigator)) return;

          if ('connection' in navigator && !navigator.onLine) return;

          try {
            const resp = await fetch(swUrl, {
              method: 'HEAD',
              cache: 'no-store',
              headers: {
                cache: 'no-store',
                'cache-control': 'no-cache',
              },
            });

            if (resp?.status === 200) await r.update();
          } catch {}
        }, 10 * 60 * 1000);
    },
  });

  return (
    <UpdateNotification
      render={needRefresh}
      onUpdate={() => updateServiceWorker(true)}
    />
  );
}
